import { useAudioPreview } from '../store/useAudioPreview.js';

export default function PreviewButton({ id, previewUrl, deezerTrackId, size = 'md' }) {
  const status = useAudioPreview((s) => s.status);
  const currentId = useAudioPreview((s) => s.currentId);
  const progress = useAudioPreview((s) => s.progress);
  const toggle = useAudioPreview((s) => s.toggle);

  const isCurrent = currentId === id;
  const isPlaying = isCurrent && status === 'playing';
  const isLoading = isCurrent && status === 'loading';
  const hasError = isCurrent && status === 'error';
  const playable = Boolean(previewUrl || deezerTrackId);

  const dim =
    size === 'sm'
      ? 'min-h-[44px] min-w-[44px] h-11 w-11 text-[11px]'
      : 'min-h-[44px] min-w-[44px] h-11 w-11 text-sm';

  function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!playable) return;
    toggle({ id, url: previewUrl, deezerTrackId });
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!playable}
      aria-label={isPlaying ? 'Pause' : 'Écouter un extrait'}
      className={`btn relative flex shrink-0 cursor-pointer items-center justify-center rounded-full border p-0 ${dim} ${
        isCurrent
          ? 'border-accent/50 bg-accent/15 text-accent'
          : playable
            ? 'border-border bg-bg-soft text-white/80 hover:bg-white/10'
            : 'border-border/60 bg-bg-soft/50 text-white/30'
      }`}
      title={
        !playable ? 'Aperçu indisponible' : isPlaying ? 'Pause' : 'Écouter 30s'
      }
    >
      {isCurrent && (
        <svg viewBox="0 0 36 36" className="absolute inset-0" aria-hidden="true">
          <circle
            cx="18"
            cy="18"
            r="16"
            fill="none"
            stroke="rgba(255,255,255,0.1)"
            strokeWidth="2"
          />
          <circle
            cx="18"
            cy="18"
            r="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray={2 * Math.PI * 16}
            strokeDashoffset={2 * Math.PI * 16 * (1 - (progress || 0))}
            transform="rotate(-90 18 18)"
            style={{ transition: 'stroke-dashoffset 0.2s var(--ease-out-quint)' }}
          />
        </svg>
      )}
      <span className="relative" aria-hidden>
        {hasError ? (
          <span className="text-xs font-bold">!</span>
        ) : isLoading ? (
          <span className="text-xs">…</span>
        ) : isPlaying ? (
          <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
            <rect x="6" y="5" width="4" height="14" rx="1" />
            <rect x="14" y="5" width="4" height="14" rx="1" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
            <path d="M8 5v14l11-7z" />
          </svg>
        )}
      </span>
    </button>
  );
}
